export const DEFAULT_BUSINESS_MODEL = "full-desktop-platform";

export function getBusinessModel(): string {
  return import.meta.env.VITE_BUSINESS_MODEL || DEFAULT_BUSINESS_MODEL;
}

export function getCaseStudiesPath(model = getBusinessModel()): string {
  return `servicePackages/${model}/caseStudies.json`;
}

export function getServicePackagesPath(model = getBusinessModel()): string {
  return `servicePackages/${model}/servicePackages.json`;
}
